import { createContext } from 'react';

const UserContext = createContext(null);

const UserProvider = UserContext.Provider;

export { UserContext, UserProvider }